module.exports = __webpack_public_path__ + "media/durango/repara_pv-3d28c52d.jpg";